import "mdn-polyfills/Node.prototype.remove";

import Catalog from "./apps/catalog.js";
import Menu from "./apps/menu.js";
import Lk from "./apps/lk.js";
import Sliders from "./apps/sliders.js";
import Cart from "./apps/cart.js";
import PushStateObserver from "./helpers/pushStateObserver.js";
import WindowResizeObserver from "./helpers/windowResizeObserver.js";

const app = {};

app.pushStateObserver = new PushStateObserver(app);
app.windowResizeObserver = new WindowResizeObserver(app);

app.catalog = new Catalog(app);
app.menu = new Menu(app);
app.lk = new Lk(app);
app.sliders = new Sliders(app);
app.cart = new Cart(app);

window.app = app;



// WEBPACK FOOTER //
// ./src/js/index.js